import { LinkChooser } from "simplydo/react/components/Choosers/LinkChooser";
import type { ExtraMenuItemAttrs } from "simplydo/react/richtext/ui/EditMenu";

import type { ChooserState, SetChooser } from "../menuTypes";

export const getMinimalMenu = (
  chooser: ChooserState,
  setChooser: SetChooser,
) => [
  {
    name: "link",
    icon: "linkify",
    onClick: ({ commands, isActive, selectedText }: ExtraMenuItemAttrs) => {
      if (isActive) {
        commands.removeLink?.();
      } else {
        setChooser(
          "link",
          !chooser.link?.open,
          commands.insertLink,
          selectedText,
        );
      }
    },
    MenuItem: ({
      RenderItem,
      itemProps,
    }: {
      RenderItem: React.ComponentType<{ item: ExtraMenuItemAttrs }>;
      itemProps: { item: ExtraMenuItemAttrs };
    }) => (
      <LinkChooser
        trigger={
          <div>
            <RenderItem {...itemProps} />
          </div>
        }
        isOpen={!!chooser.link?.open}
        shouldFix={false}
        onClose={() => setChooser("link", false)}
        hideLinkText
        onComplete={(_text, url) => {
          (
            chooser.link?.cmd as ((data: { href: string }) => void) | undefined
          )?.({ href: url });
          setChooser("link", false);
        }}
      />
    ),
  },
];
